import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { FaBell } from "react-icons/fa";
import Nonotification from '../../assets/noNotification.jpeg'
const StickyHeaderModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notificationData , setNotificationData] = useState('')

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };



  const fetchNotifcation = async ()=>{
    const emailID = localStorage.getItem('email');
    const userMail = emailID.replace(/"/g, "");

    try {
        const response = await fetch(`https://stage.apicanada.blaccdot.com/notification/unread/${userMail}`)
        const result = await response.json()
        setNotificationData(result?.unreadNotifications || [])

    } catch (error) {
        console.error("Error fetching notifications:", error);
    }
  }

  useEffect(()=>{
   const interval = setInterval(()=>{
        fetchNotifcation()
    },10000)
    return () => clearInterval(interval); 
  },[])

  const handleSubmitNotification = async(_id)=>{
    const token = localStorage.getItem('accessToken');
    try {
       await fetch(`https://stage.apicanada.blaccdot.com/notification/read/${_id}`,{
            method:'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${token}`,
              },
        })
    } catch (error) {
        console.log('Error', error)
    }
  }

  

  const formatTime = (timestamp) => {
    const createdAt = new Date(timestamp);
    const now = new Date();
    const diffInSeconds = Math.floor((now - createdAt) / 1000);
    
    if (diffInSeconds < 60) return `${diffInSeconds} sec ago`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} hrs ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  };

  return (
    <div>
      <Button type="light"
        style={{ borderRadius: "50%", width: "40px",  position: "relative",
          height: "40px",  padding: "0",display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f5f5f5",marginRight: "10px", border: "none",
         }} onClick={showModal}>
        <FaBell style={{ fontSize: "20px", color: "#5F5F5F" }} />
        <div
          style={{ position: "absolute", bottom: "10px", right: "5px", width: "8px", height: "8px",
            borderRadius: "50%",backgroundColor: "#ff4d4f", }} />
      </Button>

      <Modal title={<h6 style={{ position: "sticky", top: 0, background: "white", padding: "10px", zIndex: 10 }}>
         NOTIFICATION</h6>}
        open={isModalOpen} onCancel={handleCancel}  footer={null}
        style={{ top: 10, width: '80%' }} bodyStyle={{ maxHeight: "400px", overflowY: "auto",  scrollbarWidth: "none" }} className="custom-scroll" >

         <div style={{ minHeight: "200px", padding: "10px" }}>
      {notificationData.length > 0 ? (
        notificationData.map((notification) => (
          <div key={notification._id}  onClick={()=> handleSubmitNotification(notification._id)}
          className="notification-content">
            <div className="title-line">
              <span className="username">{notification.title}</span>
             {!notification.isRead && <div className="unread-dot"></div>} 
            </div>
            <div className="message-line">
              <span className="follow-text">{notification.message}</span>
              <span className="timestamp">{formatTime(notification.createdAt)}</span>
            </div>

            <hr style={{ color: "#999" }} />
          </div>
        ))
      ) : (
       <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}>
        <img src={Nonotification} alt="No notificatiion yet" />
        </div>
      )}


    </div>
      </Modal>
    </div>
  );
};

export default StickyHeaderModal;
